import * as React from 'react';
import { alternateTitleColor, background, white } from '../../../../styles/colors';
import { SvgIcon } from '../../icons/SvgIcon';

interface Props extends React.SVGProps<SVGSVGElement> {
	strokeColor?: string;
	bgCircleFill?: string;
}

export const AICustomContentGraphic = ({
	width = 60,
	height = 60,
	className,
	strokeColor = alternateTitleColor,
	bgCircleFill = background,
}: Props) => {
	return (
		<SvgIcon className={className} viewBox='0 0 60 60' height={height} width={width}>
			<g fill='none' fillRule='evenodd'>
				<circle cx='30' cy='30' r='30' fill={bgCircleFill} />
				<rect x='13' y='16' width='34' height='28' rx='5' fill={white} stroke={strokeColor} strokeWidth='2' />
				<g transform='translate(21, 21)' fill={strokeColor}>
					<path d='M11,14.586 L11,12 C11,11.448 11.449,11 12,11 L14.586,11 L11,14.586 Z M2,16 L2,2 L16,2 L16,9 L12,9 C10.346,9 9,10.346 9,12 L9,16 L2,16 Z M16,0 L2,0 C0.897,0 0,0.898 0,2 L0,16 C0,17.103 0.897,18 2,18 L9,18 C9.819,18 10.835,17.58 11.414,17 L17,11.414 C17.58,10.834 18,9.819 18,9 L18,2 C18,0.898 17.103,0 16,0 L16,0 Z' />
				</g>
			</g>
		</SvgIcon>
	);
};
